
































































































import { Vue, Component } from 'vue-property-decorator'
import Arrows from '@/components/Arrows.vue'
import { getTeamMembers } from '@/services/cms'

@Component({
  metaInfo: {
    title: 'About us',
  },
  components: {
    Arrows,
  },
})
export default class About extends Vue {

  team: any[] = []

  async mounted() {
    this.team = await getTeamMembers()
  }

  memberDialog = false
  selectedMember = null
  
  viewMember(member: any) {
    this.memberDialog = true
    this.selectedMember = member;
  }
}
